<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="120px">
          <el-row>
            <el-col :span="6" >
              <el-form-item label="用户姓名/手机号">
                <el-input v-model="searchForm.keyword" placeholder="请输入用户姓名/手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="type" style="width: 80%">
                <el-select clearable filterable v-model="searchForm.type">
                  <el-option label="建议" :value="1"></el-option>
                  <el-option label="其他" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- <el-col :span="6">
              <el-form-item label="处理状态" prop="handleStatus" style="width: 80%">
                <el-select clearable filterable v-model="searchForm.handleStatus">
                  <el-option label="未处理" :value="-1"></el-option>
                  <el-option label="已处理" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- <div style="margin: 20px">
        <el-button size="small" type="primary" style="width: 90px">
          <a href="" download style="color: #fff">导出</a></el-button
        >
      </div> -->
      <el-table :data="tableData" border style="width: 100%">
        <!-- <el-table-column prop="ind" label="序号" align="center" :fit="true"> 
        </el-table-column>   
        <el-table-column prop="houseNumber" label="房间信息" align="center" :fit="true"> 
        </el-table-column>           -->
        <el-table-column prop="type" label="类型" align="center" :formatter="typeList" :fit="true"> 
        </el-table-column>
        <el-table-column prop="content" label="内容" align="center" :fit="true">
        </el-table-column>
        <el-table-column prop="userName" label="用户名称" align="center" :fit="true"> 
        </el-table-column>                 
        <el-table-column prop="phone" label="手机号" align="center" :fit="true"> 
        </el-table-column> 
       
        <!-- <el-table-column prop="img" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="item" v-viewer v-for="(item,ind) in scope.row.img.split(',')" :key="ind" min-width="70" height="70" style="cursor: pointer;" />
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="handleStatus" label="处理状态" align="center" :formatter="handleStatus">
        </el-table-column> -->
        <el-table-column prop="createTime" label="反馈时间" align="center" :fit="true">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-button @click="onView(scope.row)" type="text" size="small"
              >查看详情</el-button
            >
            <!-- <el-button v-if="scope.row.handleStatus == -1" @click="handleClick(scope.row)" type="text" size="small"
              >处理</el-button
            > -->
            <!-- <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
            <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>

      <el-dialog title="详情" :visible.sync="isAddModals" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          label-position="left"
          style="margin: 0 20px;"
        >
          <el-form-item label="反馈所属类型：">
            <div>{{ addData.type == 1?'建议': addData.type == 3?'其他':'' }}</div>
          </el-form-item>
          <el-form-item label="描述内容：">
            <div>{{ addData.content }}</div>
          </el-form-item>
          <el-form-item label="上传的图片：">
            <div v-if="addData.img">
              <el-image style="width: 100px;height: 100px;margin: 0 10px 10px 0;" fit="cover" :src="item" v-for="(item,i) in addData.img.split(',')" :preview-src-list="addData.img.split(',')"></el-image>
            </div>
          </el-form-item>
          <el-form-item label="用户姓名：">
            <div>{{ addData.userName }}</div>
          </el-form-item>
          <el-form-item label="手机号码：">
            <div>{{ addData.phone }}</div>
          </el-form-item>
          <el-form-item label="性别：">
            <div>{{ addData.sex == 1?'男':'女' }}</div>
          </el-form-item>
          <el-form-item label="房屋信息：">
            <div>{{ addData.houseNumber }}</div>
          </el-form-item>
          <el-form-item label="提交时间：">
            <div>{{ addData.createTime }}</div>
          </el-form-item>
        </el-form>

      </el-dialog>
          <!-- 新增模态框 -->
      <el-dialog title="回复" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="描述" prop="handleDes">
                <el-input
                  type="textarea"
                  placeholder="请输入描述"
                  maxlength="500"
                  rows="5"
                  v-model="addData.handleDes"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { store } from 'vuex';
export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      addData:{},
      isAddModal:false,
      isAddModals:false,
      addDataRules: {
        handleDes: [
          { required: true, message: "请输入描述", trigger: "blur" },
        ],
      },
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onView(row){
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModals = true
    },
    del(row) {
      this.$confirm("您确定要删除该条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.feedbackDel({ id: row.id }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");
            this.onLoad();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    handleStatus(row){
      if(row.handleStatus == 1){
        return "已处理"
      }else{
        return "未处理"
      }
    },
    handleClick(row){
      this.addData.id = row.id;
      this.isAddModal = true;
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            handleDes: this.addData.handleDes,
          };
          this.$Apis.feedbackhandle(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 投诉类型
    typeList(row){
      if(row.type == 1){
        return '建议'
      }else if(row.type == 2){
        return '投诉'
      }else{
        return '其他'
      }
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
      };
      this.$Apis.feedbackList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
          });
          // handleStatus
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.$store.commit('setMsgTouSu',total)
          this.tableData = list;
        }
      });
      this.$Apis.feedbackuntreatedCount().then(res=>{
        this.$store.commit('setMsgTouSu',res.data)
      })
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
  },
};
</script>

<style>
</style>